import { render, staticRenderFns } from "./AmazonEBaySetup.vue?vue&type=template&id=24d2b083&"
import script from "./AmazonEBaySetup.vue?vue&type=script&lang=ts&"
export * from "./AmazonEBaySetup.vue?vue&type=script&lang=ts&"
import style0 from "./AmazonEBaySetup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports